<template>
  <v-container fluid class="page--home pos-relative d-flex">
    <v-container class="layout-container py-12">
      <v-row class="pt-6">
        <!-- greeting -->
        <v-col cols="12" sm="8" align-self="center" class="text-center text-sm-left">
          <h2 class="text-h6  font-weight-semibold">
            <span v-if="user">Welcome back, {{ user.name }}!</span>
            <span v-else class="text-uppercase">Welcome to</span>
          </h2>
          <h1 v-if="!user" class="text-h4 text-uppercase font-weight-bold primary400--text">
            bandit.camp
          </h1>
          <!-- <h2 v-else class="text-h5 font-weight-bold blue400--text" v-text="user.name" /> -->
          <p v-if="!user" class="text-body-1 mb-3 text--secondary">
            The true immersive Rust gaming experience
          </p>
        </v-col>

        <v-col cols="12" sm="4" align-self="center" class="text-center text-sm-right pt-0 pt-sm-4">
          <h4 class="font-weight-semibold text-body-1">
            <fai :icon="['fad', 'users']" class="primary400--text" />
            {{ onlineCount | toLocale }}
            bandits online
          </h4>
        </v-col>


        <v-col v-if="giveawayBannerUrl" cols="12">
          <router-link :to="{name: 'Giveaway'}" class="home-card" tag="div">
            <v-img
              :src="giveawayBannerUrl"
              :aspect-ratio="4"
              class="flex-shrink-0"
            />
          </router-link>
        </v-col>


        <v-col cols="12" class="mb-4">
          <WinFeed class="mb-6" />
          <HomeSlider :user="user" />
        </v-col>


        <v-col v-if="!config.caseBattles.disabled" cols="12" lg="8" offset-lg="2">
          <router-link :to="{name: 'Crate Battles'}" tag="div">
            <HomeGameCaseBattles :stats="gameStats.caseBattles" :conga="conga" />
          </router-link>
        </v-col>

        <v-col v-if="!config.wheel.disabled" cols="12" sm="6">
          <router-link :to="{name: 'Wheel'}" tag="div">
            <HomeGameWheel :stats="gameStats.wheel" :conga="conga" />
          </router-link>
        </v-col>

        <v-col v-if="!config.cases.disabled" cols="12" sm="6">
          <router-link :to="{name: 'Cases'}" tag="div">
            <HomeGameCases :stats="gameStats.cases" :conga="conga" />
          </router-link>
        </v-col>


        <v-col v-if="!config.dice.disabled" cols="12" sm="12" md="4">
          <router-link :to="{name: 'Beancan Blast'}" tag="div">
            <HomeGameDice :stats="gameStats.dice" :conga="conga" />
          </router-link>
        </v-col>
        <v-col v-if="!config.spinners.disabled" cols="12" sm="6" md="4">
          <router-link :to="{name: 'Spinners'}" tag="div">
            <HomeGameSpinners :stats="gameStats.spinners" :conga="conga" />
          </router-link>
        </v-col>
        <v-col v-if="!config.coinflip.disabled" cols="12" sm="6" md="4">
          <router-link :to="{name: 'Coinflip'}" tag="div">
            <HomeGameCoinflip :stats="gameStats.coinflip" :conga="conga" />
          </router-link>
        </v-col>

        <!-- promos -->
        <v-col cols="12">
          <a
            class="green800 home-card green100--text d-flex align-center py-3 px-4"
            @click="onPromoClick"
          >
            <fai :icon="['fad', 'gift-card']" class="ml-2 mr-4 text-h5" />
            <div>
              <h4 class="text-body-1 lh-1-3 font-weight-bold">
                GET FREE MONEY!
              </h4>
              <p class="text-body-2 lh-1-3 mb-0">8 ways to make scrap instantly, click here to learn more</p>
            </div>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import WinFeed from '@/components/layout/WinFeed'
import HomeGameWheel from './components/HomeGameWheel'
import HomeGameCases from './components/HomeGameCases'
import HomeGameCaseBattles from './components/HomeGameCaseBattles'
import HomeGameSpinners from './components/HomeGameSpinners'
import HomeGameCoinflip from './components/HomeGameCoinflip'
import HomeGameDice from './components/HomeGameDice'
import HomeSlider from './components/HomeSlider'

export default {
  components: {
    HomeGameWheel,
    HomeGameCases,
    HomeGameCaseBattles,
    HomeGameSpinners,
    HomeGameCoinflip,
    HomeGameDice,
    HomeSlider,
    WinFeed,
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
      onlineCount: 'online',
      conga: 'conga/conga',
      gamesSummaries: 'gamesSummaries',
    }),
    config() {
      return this.conga.games
    },
    gameStats() {
      const { gamesSummaries } = this

      return {
        wheel: gamesSummaries?.wheel,
        spinners: gamesSummaries?.spinners,
        coinflip: gamesSummaries?.coinflip,
        cases: gamesSummaries?.cases,
        dice: gamesSummaries?.dice,
        caseBattles: gamesSummaries?.caseBattles,
      }
    },
    giveawayBannerUrl() {
      const { giveaway } = this.conga.promo
      return giveaway?.advertise && giveaway?.bannerUrl
    },
  },
  methods: {
    onPromoClick() {
      if (!this.user) {
        this.$modal.open('auth', { maxWidth: 320, persistent: true })
        return
      }

      this.$modal.open('promo', { maxWidth: 400 })
    },
  },
}
</script>

<style lang="scss" scoped>
.page--home {
  min-height: calc(100vh - var(--top));
  background: grey(900); // fallback
  background: url('../../assets/img/homepage.jpg') no-repeat top center;
  background-size: cover;

  &::before {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(grey(700), 0.75) 20%, rgba(grey(800), 0.8) 80%);
    content: ' ';
  }
}

.layout-container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
}

.home-card {
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
}
</style>
